import { createSlice } from "@reduxjs/toolkit";

const accountCompleteSlice = createSlice({
  name: "accountComplete",
  initialState: {
    showAccountComplete: false,
  },
  reducers: {
    setShowAccountComplete: (prevState, action) => {
      const state = prevState;
      state.showAccountComplete = action.payload.showAccountComplete;
    },
  },
  selectors: {
    showAccountCompleteSelector: (state) => state.showAccountComplete,
  },
});

export const { showAccountCompleteSelector } = accountCompleteSlice.selectors;
export const { setShowAccountComplete } = accountCompleteSlice.actions;

export default accountCompleteSlice.reducer;
